export default __webpack_public_path__ + "static/media/product6.c910edc2.webp";